module.exports = __webpack_public_path__ + "static/media/SHSProdIcons_Alexa.34207040.svg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/pages/homepage/resources/SHSProdIcons_Alexa.svg
// module id = 3427
// module chunks = 0